import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { useAuthStore } from "./state/authStore";
import { isPublicPath } from "./auth/publicPaths";
import { useT, useDictReady, LocaleProvider } from "./i18n/i18n";
import "./styles.css";
function Splash() {
    const t = useT();
    return (_jsx("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--bg-0)", color: "var(--fg-3)", fontSize: 13, fontFamily: "var(--font-mono, monospace)" }, children: t("shell.boot.initializing") }));
}
function Root() {
    const bootstrapped = useAuthStore((s) => s.bootstrapped);
    const [started, setStarted] = useState(false);
    const dictReady = useDictReady();
    useEffect(() => {
        // На /login и /activate сессии по определению нет — GET /api/me там бессмысленный
        // 401 (и раньше валил редиректом на /login прямо со страницы активации).
        if (isPublicPath(window.location.pathname)) {
            setStarted(true);
            return;
        }
        useAuthStore.getState().bootstrap().finally(() => setStarted(true));
    }, []);
    // На публичных путях authStore.bootstrapped намеренно не взводится (bootstrap() не звался) —
    // ждать его тут значило бы вечный сплэш. Словарь ждём на ЛЮБОМ пути — иначе App успевает
    // отрисоваться до прихода чанка, и t() покажет голые ключи (auth.activate.heading и т.п.).
    const ready = isPublicPath(window.location.pathname) ? started : started && bootstrapped;
    if (!ready || !dictReady)
        return _jsx(LocaleProvider, { children: _jsx(Splash, {}) });
    return _jsx(App, {});
}
const container = document.getElementById("root");
if (!container)
    throw new Error("Root element #root not found");
const root = createRoot(container);
root.render(_jsx(Root, {}));
